import {DEFAULT_SORT, isValidSortOrder, type SortOrderType} from '../types'

// These helpers treat `sort:` as a standalone token in a space-separated query string.
// This is a simple convention (matching how GitHub search qualifiers work) rather than
// a full query parser. It assumes `sort:` won't appear as literal search text.

export function getSortFromQuery(query: string): string {
  const term = query.split(' ').find(t => t.startsWith('sort:'))
  if (!term) return ''
  return term.substring('sort:'.length)
}

export function setSortInQuery(query: string, sort: string): string {
  const newToken = sort ? `sort:${sort}` : ''
  const otherTerms = query.split(' ').filter(t => !t.startsWith('sort:'))
  const base = otherTerms.join(' ').trim()
  if (!base) return newToken
  return newToken ? `${base} ${newToken}` : base
}

export function parseSortFromQuery(query: string): SortOrderType {
  const sortValue = getSortFromQuery(query)
  return isValidSortOrder(sortValue) ? sortValue : DEFAULT_SORT
}
